import { PD_GOOD_TYPE } from '@ecp/common/src/const/good';

export const ORDER_CHANGE_STATUS = {
  PAY_WAIT: ['1010'],
  DELIVERY_PLACE_WAIT: ['1015'],
  PAY_FINISH: ['1020'],
  ORDER_CONFIRMING: ['1030'],
  GOOD_PREPARE: ['1040'],
  DELIVERING: ['1050', '1070'],
  BUY_CONFIRMATION: ['1060'],
  DELIVERY_FINISH: ['1080'],
  CANCEL_FINISH: ['2010', '2020', '2030'],
  RETURN_RECEIPT: ['3020'],
  RETURN_CANCEL: ['3025'],
  RETURN_CONFIRMING: ['3030'],
  RETURN_WITHDRAWAL_FINISH: ['3040'],
  REFUND_FINISH: ['3060'],
  RETURN_REJECT: ['3070'],
  CHANGE_RECEIPT: ['4010'],
  CHANGE_CANCEL: ['4015'],
  CHANGE_CONFIRMING: ['4020'],
  CHANGE_RETURN_FINISH: ['4030'],
  CHANGE_WITHDRAWAL_FINISH: ['4030', '4040'],
  CHANGE_GOOD_PREPARE: ['4040'],
  CHANGE_DELIVERING: ['4050', '4060'],
  CHANGE_SHIPMENT_FINISH: ['4050'],
  CHANGE_GOOD_DELIVERING: ['4060'],
  CHANGE_DELIVERY_FINISH: ['4070'],
  CHANGE_REJECT: ['4080'],
  CHANGE_BUY_CONFIRMATION: ['4090'],
};

// OD0010
export const ORDER_TYPE = {
  GENERAL: '10',
  DEPUTY: '30',
  VIP: '40',
  BATCH: '50',
  RENTAL: '80',
  REGULAR_DELIVERY: '81',
  GIFTISHOW: '82',
  PARKPOINT: '83',
  TICKET: '84',
  COOP: '85',
};

// PV0002
export const GOOD_TYPE = {
  RENTAL: [PD_GOOD_TYPE.RENTAL],
  PARK_POINT: [PD_GOOD_TYPE.PARK_POINT],
  GIFT_CARD: [PD_GOOD_TYPE.GIFT_CARD],
  TICKET: [PD_GOOD_TYPE.TICKET],
  GIFTISHOW: [PD_GOOD_TYPE.GIFTISHOW],
  COOP: [PD_GOOD_TYPE.COOP],
};

export const ORDER_STEPS = {
  cart: { name: '장바구니', id: 'cart' },
  payment: { name: '주문결제', id: 'payment' },
  complete: { name: '주문완료', id: 'complete' },
};

export const DELIVERY_FORM_CODE = {
  DIRECT: '10',
  PARCEL: '11',
  POST: '50',
  PICKUP: '60',
};

// MB0019
export const CART_GROUP_CODE = {
  NORMAL: '10', //일반
  FAMILY_SALE: '20', //패밀리세일
  PERIOD: '30', //정기배송
};

export const CART_GROUP_TYPE = {
  GENERAL: 'general',
  FAMILY_SALE: 'family_sale',
};

export const GOOD_TYPES_IMPOSSIBLE_ORDER_TOGETHER = [
  PD_GOOD_TYPE.TICKET,
  PD_GOOD_TYPE.GIFTISHOW,
  PD_GOOD_TYPE.GIFT_CARD,
  PD_GOOD_TYPE.PARK_POINT,
  PD_GOOD_TYPE.RENTAL,
  PD_GOOD_TYPE.REGULAR_DELIVERY,
  PD_GOOD_TYPE.SSL_CPN_GOOD, // ECMJ - 박준석
];

export const GOOD_TYPES_MSG_KEYWORD = {
  10: '일반',
  13: '주류',
  14: '렌탈',
  15: '정기배송',
  17: 'SET',
  20: '상품권',
  60: '해외직구',
  50: '티켓',
  16: '파크상품권',
  80: 'E상품권',
  87: 'E상품권(수기발송)', // ECMJ - 박준석
};

export const GOOD_TYPES_NO_DELIVERY = [PD_GOOD_TYPE.TICKET, PD_GOOD_TYPE.GIFTISHOW, PD_GOOD_TYPE.PARK_POINT, PD_GOOD_TYPE.SSL_CPN_GOOD]; // ECMJ - 박준석 : SSL_CPN_GOOD 추가

export const DEPARTMENT_STORE_DIVISION_CODE = {
  NONE: '99',
  HYUNDAI: '10',
};

export const MAX_REVIEW_SAVE_MONEY = 150;
export const MAX_REVIEW_FOOD_SAVE_MONEY = 50;

// PV0003 : good const -> PD_GOOD_PRGS_STAT

// PV0071 : good const -> PD_DELI_COST_FORM

// PV0061 : 주문가능기준코드
// '10', // 주문단위,주문단위
// '20', // 회원단위,회원단위
// '30', // 주문최대1+회원단위,주문최대1+회원단위
// '40', // 일별단위,일별단위
// '50', // 금액단위,금액단위

// xhere 회사명... asis 코드에서 발췌
export const HIDE_FAMILY_CART_COMPANY_LIST = ['삼성전자', '디스플레이', '삼성카드', '로지텍', '메디슨'];
// 접근 불가한 회사명 추가
//   comp_nm.indexOf("삼성전자") > -1 ||
//   comp_nm.indexOf("디스플레이") > -1 ||
//   comp_nm.indexOf("로지텍") > -1 ||
//   comp_nm.indexOf("메디슨") > -1 ||
//   comp_nm.indexOf("삼성카드") > -1
